import { memo } from 'react'

interface PhotoCameraIconProps {
  size?: number
}

const PhotoCameraIcon: React.FC<PhotoCameraIconProps> = memo(
  ({ size = 17 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 73"
      fill="none"
    >
      <path
        d="M61.2 14.9H55.4904L51.8904 11.3C49.806 9.21555 46.1484 7.69995 43.2 7.69995H28.8C25.8516 7.69995 22.194 9.21555 20.1096 11.3L16.5096 14.9H10.8C4.8456 14.9 0 19.7456 0 25.7V54.5C0 60.4543 4.8456 65.2999 10.8 65.2999H61.2C67.1544 65.2999 72 60.4543 72 54.5V25.7C72 19.7456 67.1544 14.9 61.2 14.9ZM36 50.8999C32.6578 50.8995 29.4527 49.5713 27.0897 47.2077C24.7268 44.8441 23.3995 41.6386 23.4 38.2963C23.4005 34.9541 24.7286 31.749 27.0923 29.3861C29.4559 27.0231 32.6614 25.6959 36.0036 25.6964C39.3458 25.6968 42.5509 27.025 44.9139 29.3886C47.2768 31.7522 48.6041 34.9577 48.6036 38.2999C48.6031 41.6422 47.275 44.8473 44.9113 47.2102C42.5477 49.5732 39.3422 50.9004 36 50.8999ZM57.6 33.9763C56.9854 33.9763 56.3768 33.8553 55.809 33.6201C55.2412 33.3849 54.7253 33.0402 54.2907 32.6056C53.8562 32.171 53.5114 31.6551 53.2762 31.0873C53.041 30.5195 52.92 29.9109 52.92 29.2963C52.92 28.6818 53.041 28.0732 53.2762 27.5054C53.5114 26.9376 53.8562 26.4217 54.2907 25.9871C54.7253 25.5525 55.2412 25.2078 55.809 24.9726C56.3768 24.7374 56.9854 24.6164 57.6 24.6164C58.8412 24.6164 60.0316 25.1094 60.9093 25.9871C61.7869 26.8648 62.28 28.0551 62.28 29.2963C62.28 30.5376 61.7869 31.7279 60.9093 32.6056C60.0316 33.4833 58.8412 33.9763 57.6 33.9763Z"
        fill="currentColor"
      />
    </svg>
  ),
)

export { PhotoCameraIcon }
